var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.mode === "DESIGN"
        ? [
            _c("el-input", {
              staticClass: "disabled-box-true",
              attrs: {
                size: "small",
                disabled: "",
                placeholder: "显示发起人的入职日期",
              },
            }),
          ]
        : [
            !_vm.readerMode || _vm.perm === "E"
              ? _c("el-input", {
                  attrs: {
                    size: "small",
                    clearable: "",
                    placeholder: _vm.placeholder,
                    disabled: _vm.perm === "R",
                    maxlength: "50",
                    "show-word-limit": "",
                  },
                  model: {
                    value: _vm.placeholder,
                    callback: function ($$v) {
                      _vm.placeholder = $$v
                    },
                    expression: "placeholder",
                  },
                })
              : _c("div", { staticClass: "form-item-text" }, [
                  _vm._v(_vm._s(_vm._value)),
                ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }